<template>
    <div>
        <el-select
            :class="selectBg"
            placeholder="請選擇地區"
            v-model="inputVal"
            style="min-width: 300px;"
            no-match-text="沒有匹配資料"
            autocomplete="off"
            name="none"
            filterable
            :filter-method="filterMethod"
            :disabled="disabled"
            @keydown.native.capture.enter="preventIMESelect"
        >
            <el-option-group :class="groupBg" v-for="group in countryFiltered" :key="group.label" :label="group.label">
                <el-option :disabled="item.disabled" v-for="item in group.options" :key="item.label" :label="item.value" :value="item.value" type="button">
                    <span style="float: left">{{ item.value }}</span>
                    <span style="float: right; color: #8492a6; font-size: 13px">{{ item.label }}</span>
                </el-option>
            </el-option-group>
        </el-select>
    </div>
</template>
<script>
export default {
    name: 'CountrySelect',
    props: {
        // title: {
        //   Type: String,
        //   default: ""
        // },
        value: {
            Type: String,
            default: null,
        },
        selectBg: {
            Type: String,
            default: '',
        },
        groupBg: {
            Type: String,
            default: '',
        },
        popularCity: {
            Type: Object,
            default: null,
        },
        disabled: Boolean,
    },
    data() {
        return {
            country: [
                {
                    label: '常用',
                    options: [
                        { label: 'United States', value: '美國' },
                        { label: 'China', value: '中國' },
                        { label: 'Japan', value: '日本' },
                        { label: 'Korea', value: '韓國' },
                        { label: 'United Kiongdom', value: '英國' },
                        { label: 'Taiwan', value: '台灣' },
                    ],
                },
                {
                    value: '所有',
                    options: [
                        { label: 'Angola', value: '安哥拉' },
                        { label: 'Afghanistan', value: '阿富汗' },
                        { label: 'Albania', value: '阿爾巴尼亞' },
                        { label: 'Algeria', value: '阿爾及利亞' },
                        { label: 'Andorra', value: '安道爾共和國' },
                        { label: 'Anguilla', value: '安圭拉島' },
                        { label: 'Antigua and Barbuda', value: '安提瓜和巴布達' },
                        { label: 'Argentina', value: '阿根廷' },
                        { label: 'Armenia', value: '亞美尼亞' },
                        { label: 'Ascension', value: '阿森松' },
                        { label: 'Australia', value: '澳大利亞' },
                        { label: 'Austria', value: '奧地利' },
                        { label: 'Azerbaijan', value: '阿塞拜疆' },
                        { label: 'Bahamas', value: '巴哈馬' },
                        { label: 'Bahrain', value: '巴林' },
                        { label: 'Bangladesh', value: '孟加拉國' },
                        { label: 'Barbados', value: '巴巴多斯' },
                        { label: 'Belarus', value: '白俄羅斯' },
                        { label: 'Belgium', value: '比利時' },
                        { label: 'Belize', value: '伯利茲' },
                        { label: 'Benin', value: '貝寧' },
                        { label: 'Bermuda Is', value: '百慕大群島' },
                        { label: 'Bolivia', value: '玻利維亞' },
                        { label: 'Botswana', value: '博茨瓦納' },
                        { label: 'Brazil', value: '巴西' },
                        { label: 'Brunei', value: '文萊' },
                        { label: 'Bulgaria', value: '保加利亞' },
                        { label: 'Burkina Faso', value: '布基納法索' },
                        { label: 'Burma', value: '緬甸' },
                        { label: 'Burundi', value: '布隆迪' },
                        { label: 'Cameroon', value: '喀麥隆' },
                        { label: 'Canada', value: '加拿大' },
                        { label: 'Cayman Is', value: '開曼群島' },
                        { label: 'Central African Republic', value: '中非共和國' },
                        { label: 'Chad', value: '乍得' },
                        { label: 'Chile', value: '智利' },
                        { label: 'China', value: '中國' },
                        { label: 'Colombia', value: '哥倫比亞' },
                        { label: 'Congo', value: '剛果' },
                        { label: 'Cook Is', value: '庫克群島' },
                        { label: 'Costa Rica', value: '哥斯達黎加' },
                        { label: 'Cuba', value: '古巴' },
                        { label: 'Cyprus', value: '塞浦路斯' },
                        { label: 'Czech Republic', value: '捷克' },
                        { label: 'Denmark', value: '丹麥' },
                        { label: 'Djibouti', value: '吉布提' },
                        { label: 'Dominica Rep', value: '多米尼加共和國' },
                        { label: 'Ecuador', value: '厄瓜多爾' },
                        { label: 'Egypt', value: '埃及' },
                        { label: 'EI Salvador', value: '薩爾瓦多' },
                        { label: 'Estonia', value: '愛沙尼亞' },
                        { label: 'Ethiopia', value: '埃塞俄比亞' },
                        { label: 'Fiji', value: '斐濟' },
                        { label: 'Finland', value: '芬蘭' },
                        { label: 'France', value: '法國' },
                        { label: 'French Guiana', value: '法屬圭亞那' },
                        { label: 'French Polynesia', value: '法屬玻利尼西亞' },
                        { label: 'Gabon', value: '加蓬' },
                        { label: 'Gambia', value: '岡比亞' },
                        { label: 'Georgia', value: '格魯吉亞' },
                        { label: 'Ghana', value: '加納' },
                        { label: 'Gibraltar', value: '直布羅陀' },
                        { label: 'Greece', value: '希臘' },
                        { label: 'Grenada', value: '格林納達' },
                        { label: 'Guam', value: '關島' },
                        { label: 'Guatemala', value: '危地馬拉' },
                        { label: 'Guinea', value: '幾內亞' },
                        { label: 'Guyana', value: '圭亞那' },
                        { label: 'Haiti', value: '海地' },
                        { label: 'Honduras', value: '洪都拉斯' },
                        { label: 'Hungary', value: '匈牙利' },
                        { label: 'Iceland', value: '冰島' },
                        { label: 'India', value: '印度' },
                        { label: 'Indonesia', value: '印度尼西亞' },
                        { label: 'Iran', value: '伊朗' },
                        { label: 'Iraq', value: '伊拉克' },
                        { label: 'Ireland', value: '愛爾蘭' },
                        { label: 'Israel', value: '以色列' },
                        { label: 'Italy', value: '意大利' },
                        { label: 'Ivory Coast', value: '科特迪瓦' },
                        { label: 'Jamaica', value: '牙買加' },
                        { label: 'Japan', value: '日本' },
                        { label: 'Jordan', value: '約旦' },
                        { label: 'Cambodia', value: '柬埔寨' },
                        { label: 'Kazakstan', value: '哈薩克斯坦' },
                        { label: 'Kenya', value: '肯尼亞' },
                        { label: 'Korea', value: '韓國' },
                        { label: 'Kuwait', value: '科威特' },
                        { label: 'Kyrgyzstan', value: '吉爾吉斯坦' },
                        { label: 'Laos', value: '老撾' },
                        { label: 'Latvia', value: '拉脫維亞' },
                        { label: 'Lebanon', value: '黎巴嫩' },
                        { label: 'Lesotho', value: '萊索托' },
                        { label: 'Liberia', value: '利比里亞' },
                        { label: 'Libya', value: '利比亞' },
                        { label: 'Liechtenstein', value: '列支敦士登' },
                        { label: 'Lithuania', value: '立陶宛' },
                        { label: 'Luxembourg', value: '盧森堡' },
                        { label: 'Madagascar', value: '馬達加斯加' },
                        { label: 'Malawi', value: '馬拉維' },
                        { label: 'Malaysia', value: '馬來西亞' },
                        { label: 'Maldives', value: '馬爾代夫' },
                        { label: 'Mali', value: '馬里' },
                        { label: 'Malta', value: '馬耳他' },
                        { label: 'Mariana Is', value: '馬里亞那群島' },
                        { label: 'Martinique', value: '馬提尼克' },
                        { label: 'Mauritius', value: '毛里求斯' },
                        { label: 'Mexico', value: '墨西哥' },
                        { label: 'Moldova', value: '摩爾多瓦' },
                        { label: 'Monaco', value: '摩納哥' },
                        { label: 'Mongolia', value: '蒙古' },
                        { label: 'Montserrat Is', value: '蒙特塞拉特島' },
                        { label: 'Morocco', value: '摩洛哥' },
                        { label: 'Mozambique', value: '莫桑比克' },
                        { label: 'Namibia', value: '納米比亞' },
                        { label: 'Nauru', value: '瑙魯' },
                        { label: 'Nepal', value: '尼泊爾' },
                        { label: 'Netheriands Antilles', value: '荷屬安的列斯' },
                        { label: 'Netherlands', value: '荷蘭' },
                        { label: 'New Zealand', value: '新西蘭' },
                        { label: 'Nicaragua', value: '尼加拉瓜' },
                        { label: 'Niger', value: '尼日爾' },
                        { label: 'Nigeria', value: '尼日利亞' },
                        { label: 'North Korea', value: '朝鮮' },
                        { label: 'Norway', value: '挪威' },
                        { label: 'Oman', value: '阿曼' },
                        { label: 'Pakistan', value: '巴基斯坦' },
                        { label: 'Panama', value: '巴拿馬' },
                        { label: 'Papua New Cuinea', value: '巴布亞新幾內亞' },
                        { label: 'Paraguay', value: '巴拉圭' },
                        { label: 'Peru', value: '秘魯' },
                        { label: 'Philippines', value: '菲律賓' },
                        { label: 'Poland', value: '波蘭' },
                        { label: 'Portugal', value: '葡萄牙' },
                        { label: 'Puerto Rico', value: '波多黎各' },
                        { label: 'Qatar', value: '卡塔爾' },
                        { label: 'Reunion', value: '留尼旺' },
                        { label: 'Romania', value: '羅馬尼亞' },
                        { label: 'Russia', value: '俄羅斯' },
                        { label: 'Samoa Eastern', value: '東薩摩亞(美)' },
                        { label: 'Samoa Western', value: '西薩摩亞' },
                        { label: 'San Marino', value: '聖馬力諾' },
                        { label: 'Sao Tome and Principe', value: '聖多美和普林西比' },
                        { label: 'Saudi Arabia', value: '沙特阿拉伯' },
                        { label: 'Senegal', value: '塞內加爾' },
                        { label: 'Seychelles', value: '塞舌爾' },
                        { label: 'Sierra Leone', value: '塞拉利昂' },
                        { label: 'Singapore', value: '新加坡' },
                        { label: 'Slovakia', value: '斯洛伐克' },
                        { label: 'Slovenia', value: '斯洛文尼亞' },
                        { label: 'Solomon Is', value: '所羅門群島' },
                        { label: 'Somali', value: '索馬里' },
                        { label: 'South Africa', value: '南非' },
                        { label: 'Spain', value: '西班牙' },
                        { label: 'SriLanka', value: '斯里蘭卡' },
                        { label: 'St.Lucia', value: '聖盧西亞' },
                        { label: 'St.Vincent', value: '聖文森特' },
                        { label: 'Sudan', value: '蘇丹' },
                        { label: 'Suriname', value: '蘇里南' },
                        { label: 'Swaziland', value: '斯威士蘭' },
                        { label: 'Sweden', value: '瑞典' },
                        { label: 'Switzerland', value: '瑞士' },
                        { label: 'Syria', value: '敘利亞' },
                        { label: 'Tajikstan', value: '塔吉克斯坦' },
                        { label: 'Tanzania', value: '坦桑尼亞' },
                        { label: 'Taiwan', value: '台灣' },
                        { label: 'Thailand', value: '泰國' },
                        { label: 'Togo', value: '多哥' },
                        { label: 'Tonga', value: '湯加' },
                        { label: 'Trinidad and Tobago', value: '特立尼達和多巴哥' },
                        { label: 'Tunisia', value: '突尼斯' },
                        { label: 'Turkey', value: '土耳其' },
                        { label: 'Turkmenistan', value: '土庫曼斯坦' },
                        { label: 'Uganda', value: '烏干達' },
                        { label: 'Ukraine', value: '烏克蘭' },
                        { label: 'United Arab Emirates', value: '阿拉伯聯合酋長國' },
                        { label: 'United Kiongdom', value: '英國' },
                        { label: 'United States', value: '美國' },
                        { label: 'Uruguay', value: '烏拉圭' },
                        { label: 'Uzbekistan', value: '烏茲別克斯坦' },
                        { label: 'Venezuela', value: '委內瑞拉' },
                        { label: 'Vietnam', value: '越南' },
                        { label: 'Yemen', value: '葉門' },
                        { label: 'Yugoslavia', value: '南斯拉夫' },
                        { label: 'Zimbabwe', value: '津巴布韋' },
                        { label: 'Zaire', value: '紮伊爾' },
                        { label: 'Zambia', value: '讚比亞' },
                    ],
                },
            ],
            countryFiltered: [],
        };
    },
    computed: {
        inputVal: {
            get() {
                return this.value;
            },
            set(val) {
                this.$emit('input', val);
            },
        },
    },
    mounted() {
        this.countryFiltered = JSON.parse(JSON.stringify(this.country));
    },
    methods: {
        filterMethod(val) {
            if (val) {
                const v = val.toLowerCase();
                const options = this.country[1].options.filter((c) => c.label.toLowerCase().indexOf(v) > -1 || c.value.toLowerCase().indexOf(v) > -1);
                this.countryFiltered = [{
                    label: `搜尋結果 (${options.length})`,
                    options,
                }];
            } else {
                this.countryFiltered = JSON.parse(JSON.stringify(this.country));
            }
        },
        preventIMESelect(e) {
            // keyCode 229 代表輸入法正在輸入
            if (e.keyCode === 229 || e.isComposing) {
                // 停止事件冒泡，防止觸發 Element-UI 內部的 handleKeydown
                e.stopPropagation();
            }
        },
    },
};
</script>
<style>
.groupBlue {
    background-color: #00355d;
    width: 170px;
}

.selectBlue .el-input .el-input__inner {
    background-color: #00355d;
    border: none;
    width: 170px;
}

.groupBlack {
    width: 170px;
}

.selectBlack .el-input .el-input__inner {
    border: none;
    width: 170px;
}

.groupWhite {
    background-color: #d9d9d9;
    width: 170px;
}

.selectWhite .el-input .el-input__inner {
    border: none;
    background-color: #d9d9d9;
    width: 170px;
}
</style>
